import React from "react";
import { Box } from "@mui/material";
import AttachmentsTable from "./AttachmentsTable";

export default function Attachments() {
  return (
    <Box>
      <AttachmentsTable />
    </Box>
  );
}
